import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from 'aos';
// import 'aos/dist/aos.css';
import axios from 'axios';
import { Helmet } from "react-helmet-async"; // Updated import

const About = () => {
    const [aboutData, setAboutData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_APP_URL;
    const API_URL = `${BASE_URL}/api/v1/topic/189`;

    useEffect(() => {
       
            // Initialize AOS animations only on the client-side
            AOS.init({
                duration: 1200
            });
            

        const fetchAboutData = async () => {
            try {
                const response = await axios.get(API_URL);
                setAboutData(response.data);
            } catch (err) {
                setError("Error fetching data");
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAboutData();
    }, [API_URL]);

   

    if (error) {
        return (
            <section className="sec_padding about-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p>{error}</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    // Extract the fields from the API response
    const photoFile = aboutData?.topic[0]?.fields?.find(field => field.type === 8 || field.type === "8")?.value || null;
    const paragraphOne = aboutData?.topic[0]?.fields?.find(field => field.title === "Paragraph_One")?.value || "";
    const paragraphTwo = aboutData?.topic[0]?.fields?.find(field => field.title === "Paragraph_two")?.value || "";

    return ( 
        <>
    
        <section className="sec_padding about-section">
            <div className="container">
                <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-6">
                        {/* Image Section */}
                        {photoFile && (
                            <div className="about-img wow animate__animated animate__zoomIn" data-aos="zoom-in-right">
                                <img 
                                  src={`${BASE_URL}/uploads/topics/${photoFile}`} 
                                  alt="Michele" 
                                  onError={(e) => e.target.src = "/assets/images/default-image.png"} // Fallback image
                                />
                            </div>
                        )}
                    </div>
                    <div data-aos="zoom-in-left" className="col-xl-8 col-lg-8 col-md-6 wow animate__animated animate__slideInRight">
                        {/* Title */}
                        <h2 className="sec_heading">
                            Meet <span className="sec_heading-stylish">Michele</span>
                        </h2>
                        {/* Paragraph One */}
                        {paragraphOne && (
                            <div className="pera" dangerouslySetInnerHTML={{ __html: paragraphOne }} />
                        )}
                    </div>
                    <div className="col-md-12 wow animate__animated animate__slideInUp" data-aos="zoom-in-up">
                        {/* Paragraph Two */}
                        {paragraphTwo && (
                            <div className="pera" dangerouslySetInnerHTML={{ __html: paragraphTwo }} />
                        )}
                        {/* Link to My Story */}
                        <div className="text-center">
                            <Link to="/about" className="btn theme_btn mt-3">My story</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
       
        </>
    );
};

export default About;
